import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_search_filter_field extends PureComponent {
  render() {
    return (
      <div className="row" id="component_search_filter_field">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Search Filter Field</h2>
              <p>
                Search filter field is a component that allows the user to
                filter the search results on a specific field. The filter does
                support text filtering but will treat a data field with multiple
                words as multiple possible values. For example, if the filter
                was set to the word "open" then any record with the defined
                text_field of "open" or a text field that contains the word
                "open" like "the door is open" will be included in the filter.
                Note this will not include text data where the characters "open"
                exist but not as a word. For example, "there is an opening"
                would not be included in the results as the word "open" does not
                exist in the text.
              </p>

              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={true}
              />
              <InterfaceProperties
                type={"search_select_field"}
                name={"select field"}
                dataNameDefault={
                  '"date_my_field" or "object_my_obj.date_my_field"'
                }
                searchGroup={true}
                padding={true}
                hide={true}
                order={true}
                tabIndex={true}
                displayName={true}
                properties={[
                  {
                    property: "multiple",
                    description:
                      "	Allows the user to select multiple filter options.",
                    defaults: "true, false default true"
                  },
                  {
                    property: "options",
                    description:
                      "	This is where you set out your list of options the user can select. Options can include icons, and colors. For more detials see the table below which outlines the options properties.",
                    defaults: "{ ... }"
                  }
                ]}
              />

              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">color</td>
                    <td>
                      The color of the icon (if icon is defined). For help
                      choosing colors please refer to the colors section of this
                      documention.
                      <br />
                      <i>"4caf50"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">disabled</td>
                    <td>
                      Stops the user from being able to select this option.
                      <br />
                      <i>true or false default if false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">icon</td>
                    <td>
                      This is an options option to include an icon from the
                      material icon font. For more detials look at the icon
                      section of this document.
                      <br />
                      <i>"home"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">hide</td>
                    <td>
                      Hide this option from the interface.
                      <br />
                      <i>true or false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">name</td>
                    <td>
                      The displayed text name of the option.
                      <br />
                      <i>
                        <strong>"Select me"</strong>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      The display order of options in the list.
                      <br />
                      <i>7</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">selected</td>
                    <td>
                      Is this option selected.
                      <br />
                      <i>true or false default if false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">value</td>
                    <td>
                      The data value of the selected option.
                      <br />
                      <i>
                        <strong>"on" or 3</strong>
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Search Filter Field Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Filter Field</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"search_select_field"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"State"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"text_state"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"search_group"</span>:{" "}
                  <span className="jsonY">"record_results_1"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"multiple"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"open"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Open"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Open"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"selected"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"hold"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Hold"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Hold"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"selected"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div className="i2">&#125;,</div>
                <div className="i2">
                  <span className="jsonG">"done"</span>: &#123;
                </div>
                <div className="i3">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Done"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">3</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"value"</span>:{" "}
                  <span className="jsonY">"Done"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"selected"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div className="i2">&#125;</div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_search_filter_field;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_search_filter_field.js